import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { ITableGridItem } from '@shared/model/project-calculation/table-grid-item.interface';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  host: {
    '[style]': 'setStyle()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent {
  @Input() tableGrid!: ITableGridItem[];
  @Input() tableValue!: any;

  findValues(key?: any): [] {
    if (!this.tableValue) return [];
    if (Object.keys(this.tableValue).some((value) => key === value)) return this.tableValue[key];
    return [];
  }

  setStyle(): string {
    return `grid-template-columns: repeat(4, 1fr)`;
  }
}
